import AgreementComponent from './AgreementContainer';

export default AgreementComponent;
